var _Path, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "url(#location_svg__a)",
    fillRule: "evenodd",
    d: "M11 1.375c-4.812 0-8.25 3.438-8.25 8.25 0 4.813 8.25 11.688 8.25 11.688s8.25-6.875 8.25-11.688c0-4.812-3.437-8.25-8.25-8.25M11 5.5a3.437 3.437 0 1 0 0 6.875A3.437 3.437 0 0 0 11 5.5",
    clipRule: "evenodd"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "location_svg__a",
    x1: 6.256,
    x2: 9.019,
    y1: 1.375,
    y2: 20.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FCF17B"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#E19010"
  })))));
};
export default SvgLocation;